import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Typography } from "@mui/material";


const ConfirmDialog = (props) => {
	const { title, children, open, setOpen, onConfirm, ...other } = props;
	return (
		<Dialog
			open={open}
			onClose={() => setOpen(false)}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description" 
			{...other}
			>
			<DialogTitle id="confirm-dialog" variant="h6">{title}</DialogTitle>
			<DialogContent>
				<Typography variant="body">
					{children}
				</Typography>
			</DialogContent>
			<DialogActions sx={{paddingBottom: 2, paddingRight: 2}}>
				<Button variant='contained' color='secondary' onClick={() => setOpen(false)}>Não</Button>
				<Button variant='contained' onClick={() => {setOpen(false);onConfirm();}}>Sim, Prosseguir</Button>
			</DialogActions>
		</Dialog>
	);
};

export default ConfirmDialog;